module.exports = __webpack_public_path__ + "static/media/brain.93118e06.png";